module.exports = __webpack_public_path__ + "static/roberts_michael_2-926c1e8e5c68796fe275abe2c4e0f825.jpg";